import React from "react";
import { Provider } from "react-redux";

import AppRouter from "./AppRouter";
import store from "./store";

function App() {
  return (
    <div className="App container-fluid pl-0 pr-0 ">
      <Provider store={store}>
        <AppRouter />
      </Provider>
    </div>
  );
}

export default App;
